import Rest from '../Rest'

export default class CancellationPolicyVersionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cancellation_policy_versions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  publish(versionId: number) {
    return this.post(`/${versionId}/publish`, {})
  }
}
